export default [
  {
    Created: "Jan 2021",
    vendorname: "Harsh Dedhia",
    totalearning: "700",
    commission: "70",
    Transaction: "Paytm",
TransactionID: "105",
BaseAmount: "1500",
TDS: "140",
GST: "128",
    totalpaid: "0",
    totaldue: "630"
  },
  {
    Created: "Feb 2021",
    vendorname: "Sumit Jaiswal",
    totalearning: "4590",
    commission: "510",
    Transaction: "Paytm",
TransactionID: "105",
BaseAmount: "1500",
TDS: "140",
GST: "128",
    totalpaid: "3000",
    totaldue: "1590"
  },
  {
    Created: "Mar 2021",
    vendorname: "Jignesh Gupta",
    totalearning: "4590",
    commission: "510",
    Transaction: "Phone Pe",
TransactionID: "105",
BaseAmount: "1500",
TDS: "140",
GST: "128",
    totalpaid: "3500",
    totaldue: "1590"
  },
  {
    Created: "Apr 2021",
    vendorname: "Ajay Patel",
    totalearning: "4590",
    commission: "550",
    Transaction: "Paytm",
TransactionID: "105",
BaseAmount: "1500",
TDS: "140",
GST: "128",
    totalpaid: "4000",
    totaldue: "1290"
  }
];
